import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito Excel?',
  a: 'No. Todo es simple, sin fórmulas ni hojas complicadas. Usamos un sistema de sobres y plantillas PDF simples.'
}, {
  q: '¿Cuánto tiempo al día?',
  a: 'Unos 10 minutos al día durante los primeros 7 días. Luego solo necesitas 15 minutos cada quincena para mantener el orden.'
}, {
  q: '¿Sirve si cobro quincenal o biweekly?',
  a: 'Sí, está hecho específicamente para ciclos de pago quincenales, que tienen retos diferentes al pago mensual.'
}, {
  q: '¿Y si tengo deudas?',
  a: "Incluye el plan 'mínimo + ataque' diseñado para avanzar rápido en tus deudas sin dejar de vivir."
}, {
  q: '¿Y si gano poco?',
  a: 'Funciona con cualquier nivel de ingreso. El sistema es sobre claridad y hábitos, no sobre cuánto ganas.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Recibirás un correo con el enlace de descarga inmediata justo después de tu pago.'
}, {
  q: '¿Está en dólares?',
  a: 'Sí, el precio es $8.97 USD. Tu banco hará la conversión automática a tu moneda local si estás en otro país.'
}, {
  q: '¿Esto es asesoría financiera?',
  a: 'No, es contenido educativo y práctico basado en hábitos. No reemplaza la asesoría financiera profesional personalizada.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 bg-white" data-id="element-16">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-17">
        <h2 className="font-heading text-3xl font-bold text-brand-dark text-center mb-12" data-id="element-18">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-100 rounded-xl overflow-hidden" data-id="element-20">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 bg-brand-cream/30 hover:bg-brand-cream/50 transition-colors text-left" data-id="element-21">
                <span className="font-heading font-semibold text-brand-dark" data-id="element-22">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-green" data-id="element-23" /> : <ChevronDown className="w-5 h-5 text-brand-text/40" data-id="element-24" />}
              </button>
              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-26">
                    <div className="p-5 pt-0 text-brand-text/80 font-sans leading-relaxed" data-id="element-27">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}